import React from 'react';
import Header from '../header/Header';
import './Pages.css';
import Footer from "../footer/Footer";

const More = () => {
    return (<div className="page-wrapper">
        <Header/>
        <div className="more-page">
            <h2>Περισσότερα</h2>
            <p>
                Το Rare Diseases Greece Map είναι ένα δυναμικό εργαλείο που δημιουργήθηκε για τη χαρτογράφηση των
                Σπανίων Παθήσεων, την παροχή εξειδικευμένης και έγκυρης πληροφορίας γύρω από από αυτές, και την
                καλύτερη διασύνδεση των Ασθενών, των Oργανώσεών τους και των Κέντρων Παρακολούθησης στην Ελλάδα.
                Με τη συνεισφορά σας, συμβάλλετε στην ενίσχυση της ενημέρωσης, της πρόσβασης στη φροντίδα, και της
                διασύνδεσης των Ασθενών με τις κατάλληλες Δομές και τους Ειδικούς.
            </p>

            <h3>Υποβολή Αιτήματος για Προσθήκη μίας Σπάνιας Πάθησης</h3>
            <p>
                Ο Χάρτης εμπλουτίζεται συνεχώς με νέες πληροφορίες και παθήσεις. Αν γνωρίζετε μία Σπάνια Πάθηση που
                δεν είναι καταγεγραμμένη, μπορείτε να υποβάλετε αίτημα προσθήκης, ανεξαρτήτως του αν είστε Ασθενής,
                Επαγγελματίας Υγείας ή μέλος μιας Οργάνωσης κ.λπ..
                Θα χρειαστεί να:
            </p>
            <ul>
                <li>Συμπληρώσετε τη Φόρμα Προσθήκης Σπάνιας Πάθησης.</li>
                <li>Παρέχετε όποια από τα ακόλουθα στοιχεία γνωρίζετε για την πάθηση, όπως την ονομασία της στα
                    Ελληνικά και Αγγλικά, τον σχετικό ORPHAcode, καθώς και τα Κέντρα Παρακολούθησης που είναι
                    εξειδικευμένα για την πάθηση, εφόσον τα γνωρίζετε.
                </li>
                <li>Δηλώσετε τα στοιχεία σας σε περίπτωση που επιθυμείτε να επικοινωνούμε μαζί σας.</li>
            </ul>
            <button className="form-button"
                    onClick={() => window.open('https://de0drkd3.forms.app/ypobolh-aithmatos-gia-pros8hkh-spanias-pa8hshs-ston-ellhniko-xarth-spaniwn-pa8hsewn-rare-diseases-greece-map', '_blank')}>Φόρμα
                Προσθήκης Σπάνιας Πάθησης
            </button>

            <h3>Υποβολή Αιτήματος Εγγραφής ενός Κέντρου Παρακολούθησης</h3>
            <p>
                Εξειδικευμένα Κέντρα που παρέχουν φροντίδα και εξειδικευμένες υπηρεσίες για Σπάνιες Παθήσεις μπορούν
                να εγγραφούν στον Χάρτη, προσφέροντας πολύτιμες πληροφορίες στους Ασθενείς και στους Επαγγελματίες
                Υγείας.
                Η εγγραφή περιλαμβάνει:
            </p>
            <ul>
                <li>Συμπλήρωση της Φόρμας Εγγραφής Εξειδικευμένων Κέντρων Σπανίων Νοσημάτων.</li>
                <li>Παροχή βασικών στοιχείων του Κέντρου (όνομα, νοσοκομείο, διεύθυνση, υπεύθυνος επικοινωνίας
                    κ.λπ.).
                </li>
                <li>Καταγραφή των Σπανίων Παθήσεων που παρακολουθεί το Κέντρο.</li>
            </ul>
            <button className="form-button"
                    onClick={() => window.open('https://de0drkd3.forms.app/add-center-form-rdg', '_blank')}>Φόρμα
                Εγγραφής Εξειδικευμένων Κέντρων
            </button>

            <h3>Υποβολή Αιτήματος Εγγραφής μίας Οργάνωσης Ασθενών</h3>
            <p>
                Οι Οργανώσεις Ασθενών διαδραματίζουν κρίσιμο ρόλο στην υποστήριξη των πασχόντων, και στην προώθηση
                της ενημέρωσης για τις Σπάνιες Παθήσεις.
                Για να καταχωρηθεί μία Οργάνωση Ασθενών στον Χάρτη, απαιτείται:
            </p>
            <ul>
                <li>Συμπλήρωση της Φόρμας Εγγραφής Οργανώσεων Ασθενών.</li>
                <li>Παροχή βασικών στοιχείων της Οργάνωσης (όνομα, νομική μορφή, στοιχεία επικοινωνίας, κ.λπ.).</li>
                <li>Καταγραφή των Σπανίων Παθήσεων που εκπροσωπεί η Οργάνωση.</li>
            </ul>
            <button className="form-button"
                    onClick={() => window.open('https://de0drkd3.forms.app/ypobolh-aithmatos-gia-pros8hkh-organwshs-as8enwn-ston-ellhniko-xarth-spaniwn-pa8hsewn-rare-diseases-greece-map', '_blank')}>Φόρμα
                Εγγραφής Οργανώσεων Ασθενών
            </button>
        </div>
        <Footer/>
    </div>);
};

export default More;